module.exports = __webpack_public_path__ + "img/vuejs.c6be4c22.svg";